import comp from "./TagProjectElement.js";
export default comp;
